import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
import { featuredTestimonial, testimonials, Testimonial } from '../data/pack';
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text
}: Testimonial) {
  return <article className="glass-panel flex h-full flex-col rounded-2xl p-6 md:p-7" data-id="element-235" data-mp="3fxb5yrjhq6ge">
      <div className="mb-4 flex items-center gap-3" data-id="element-236" data-mp="3ayi11ni9rnru">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-brand-gold/55 bg-brand-surfaceLight font-display font-bold text-brand-goldDark" data-id="element-237" data-mp="36z95cd3o5ftn">
          {initials}
        </div>
        <div data-id="element-238" data-mp="2x1l0guccmrxr">
          <div className="flex text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-239" data-mp="2x11tu9s5fpz1">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-240" data-mp="v8nd3e1ccrk7" />)}
          </div>
          <p className="mt-1 font-semibold text-brand-ink" data-id="element-241" data-mp="h816vm00ecjf">{name}</p>
          <p className="text-xs text-brand-muted" data-id="element-242" data-mp="m5sz6h4kg0o5">
            {location} · {product}
          </p>
        </div>
      </div>
      <p className="font-serif text-lg leading-relaxed text-brand-text" data-id="element-243" data-mp="79li3pogffd3">
        “{text}”
      </p>
    </article>;
}
export function InitialTestimonials() {
  return <Section className="pt-6" data-id="element-244" data-mp="zxr0i5s1cs9r">
      <div className="mx-auto max-w-3xl" data-id="element-245" data-mp="zyiwvitgiu13">
        <TestimonialCard {...featuredTestimonial} data-id="element-246" data-mp="14w296d6lgwqe" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section data-id="element-247" data-mp="q5uy4iix2fzq">
      <div className="mb-10 text-center" data-id="element-248" data-mp="q6cvjihbf098">
        <h2 className="font-display text-2xl font-bold text-brand-ink md:text-3xl" data-id="element-249" data-mp="v5fy8w9toue1">
          LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="mx-auto grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-250" data-mp="1it7c44b0hfhf">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-251" data-mp="1xhqxbmoczosy" />)}
      </div>
    </Section>;
}